import {Message} from 'element-ui'
// 地图初始化
const init = function (address, type, inputId, target,callback) {
  let map = new BMap.Map(type) // 创建Map实例
  let localSearch = new BMap.LocalSearch(map)
  map.centerAndZoom(address, 15)
  map.enableScrollWheelZoom(true);

  map.addEventListener('click',function(e){
    var myGeo = new BMap.Geocoder({extensions_town: true});
      // 根据坐标得到地址描述
    myGeo.getLocation(new BMap.Point(e.Ag.lng, e.Ag.lat), function(result){
      if (result){
        callback(e.Ag,result,e.currentTarget.Ua.id)
      }
    });
    })



  // 添加带有定位的导航控件
  let navigationControl = new BMap.NavigationControl({
    // 靠左上角位置
    anchor: BMAP_ANCHOR_TOP_LEFT,
    // LARGE类型
    type: BMAP_NAVIGATION_CONTROL_LARGE,
    // 启用显示定位
    enableGeolocation: true
  })
  map.addControl(navigationControl)
  searchByStationName(address, map, localSearch)
}
const searchByStationName = function (address, map, localSearch) {
  map.clearOverlays() // 清空原来的标注
  let keyword = address
  localSearch.setSearchCompleteCallback(function (searchResult) {
    console.log(searchResult)
    let poi = searchResult.Kr[0]
    if (!poi) {
      Message({
        message: '输入的地址不正确',
        type: 'error'
      })
      return false
    }
    map.centerAndZoom(poi.point, 15)
    let marker = new BMap.Marker(new BMap.Point(poi.point.lng, poi.point.lat)) // 创建标注，为要查询的地方对应的经纬度
    map.addOverlay(marker)
  })
  localSearch.search(keyword)
}
function tip (inputId, target, type, address,callback) {
  let map = new BMap.Map(type) // 创建Map实例
  let localSearch = new BMap.LocalSearch(map)
  map.centerAndZoom(address, 15)


  map.addEventListener('click',function(e){
  var myGeo = new BMap.Geocoder({extensions_town: true});
    // 根据坐标得到地址描述
  myGeo.getLocation(new BMap.Point(e.Ag.lng, e.Ag.lat), function(result){
    if (result){
      callback(e.Ag,result,e.currentTarget.Ua.id)
    }
  });
  })



  let ac = new BMap.Autocomplete( // 建立一个自动完成的对象
    {'input': inputId}
  )
  let myValue = ''


  ac.addEventListener('onconfirm', function (e) { // 鼠标点击下拉列表后的事件
    let _value = e.item.value
    myValue = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
    target.setAttribute('data-address', myValue)
    target.blur()
    setPlace()
    // searchByStationName(myValue, map, localSearch)
    return myValue
  })
  function setPlace () {
    map.clearOverlays() // 清除地图上所有覆盖物
    function myFun () {
      let poi = local.getResults().getPoi(0).point // 获取第一个智能搜索的结果
      map.centerAndZoom(poi, 18)
      map.addOverlay(new BMap.Marker(new BMap.Point(poi.lng, poi.lat))) // 添加标注
    }
    let local = new BMap.LocalSearch(map, {
      onSearchComplete:myFun
    })
    local.search(myValue)
  }
}
export {init, tip}



// WEBPACK FOOTER //
// ./src/utils/map.js